module.exports = __webpack_public_path__ + "img/icon03.0e97d067.png";